import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Table } from 'react-bootstrap';
import { FaBan, FaCheck } from 'react-icons/fa';
const CotisationChoixSel = ({ handleChoixCotisation, cotisation, closemodal }) => {

    const handleRowClick = (e, nbfois) => {
        console.log('handleRowClick', e, nbfois);
        handleChoixCotisation(e, nbfois);
        closemodal();
    }

    useEffect(() => {
        console.log('cotisation', cotisation);
    }, [cotisation]);

    const ExpandedComponent = () => {

        let myChoix = JSON.parse(cotisation.choix);


        return <Card>
            <Card.Header>Sélectionnez votre tarif de cotisation</Card.Header>
            {/* <Card.Body> */}
            <Table striped bordered hover style={{ margin: 'auto', }}>
                <thead>
                    <tr>
                        {/* <th>Ordre</th> */}
                        <th>Libelle</th>
                        <th>Montant</th>
                        {cotisation.trois_fois === 1 && <th>En 3 fois</th>}
                        {cotisation.six_fois === 1 && <th>En 6 fois</th>}
                    </tr>
                </thead>
                <tbody>
                    {
                        myChoix.map((e) => (
                            <tr >
                                {/* <td>{e.ordre}</td> */}
                                <td style={{ backgroundColor: cotisation.choix_id === e.id ? 'bisque' : '' }}>{e.libelle}</td>
                                <td style={{ backgroundColor: cotisation.choix_id === e.id ? (cotisation.paiement_en_x_fois === 1 ? 'lightblue' : 'bisque') : '' }} onClick={() => handleRowClick(e, 1)}><Button variant='link'>{e.montant}&nbsp;€</Button></td>
                                {cotisation.trois_fois === 1 && <td style={{ backgroundColor: cotisation.choix_id === e.id ? (cotisation.paiement_en_x_fois === 3 ? 'lightblue' : 'bisque') : '' }} onClick={() => handleRowClick(e, 3)}><Button variant='link'>{Math.ceil(e.montant / 3)}&nbsp;€</Button></td>}
                                {cotisation.six_fois === 1 && <td style={{ backgroundColor: cotisation.choix_id === e.id ? (cotisation.paiement_en_x_fois === 6 ? 'lightblue' : 'bisque') : '' }} onClick={() => handleRowClick(e, 6)}><Button variant='link'>{Math.ceil(e.montant / 6)}&nbsp;€</Button></td>}
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </Card >
            // <pre>{JSON.stringify(data.choix, null, 2)}</pre>
            ;
    }

    return (
        <Card>
            {cotisation && cotisation.choix && (<>
                <Card.Header>{cotisation.titre.replace('..........', cotisation.reseau)}</Card.Header>
                <Card.Body>
                    <h5>{cotisation.libelle}</h5><br />
                    {ExpandedComponent()}
                </Card.Body>
            </>)}
        </Card>
    );
}

export default CotisationChoixSel;
